import SlimSelect from 'slim-select';

export default class CustomSelect {
    init = async (select) => {
        const dataset = select.dataset.ssid;

        if (dataset !== null && dataset !== undefined) return;

        new SlimSelect({
            select: select,
            showSearch: false,
        });
    };
}
